module.exports = __webpack_public_path__ + "assets/ic_tree20.fe41edbf.svg";